<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <nz-card style="margin-bottom: 10px;">
      <div class="条件区">
      </div>

      <form nz-form [formGroup]="validateForm">
        <div nz-row>

          <div nz-col nzSpan="2">

            <nz-form-label>
              <div class="width-100-percent label-font">{{ "Site" | translate}}
              </div>
            </nz-form-label>
            <nz-form-item>
              <nz-form-control nzSpan="20">
                <nz-select formControlName="SiteSelect" [nzAllowClear]="true" nzAllowClear
                  nzPlaceHolder="{{'ALL'|translate}}">
                  <nz-option *ngFor="let option of SiteList" [nzValue]="option.siteCode"
                    [nzLabel]="option.siteName"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>


          <div nz-col nzSpan="4">

            <nz-form-label>
              <div class="width-100-percent label-font">{{ "Name/Id" | translate}}
              </div>
            </nz-form-label>
            <nz-form-item>
              <nz-form-control nzSpan="22">
                <nz-select [nzServerSearch]="true" formControlName="SubjectIdSelect" (nzOnSearch)="userSearch($event)"
                  style="border-radius:6px;" nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true"
                  [nzShowSearch]="true">
                  <nz-option *ngFor="let o of userOptionList" [nzValue]="o.userId"
                    nzLabel="{{o.userId}}/{{o.englishName}}" nzCustomContent>
                    <span>{{o.userId}}/{{o.englishName}}</span>
                  </nz-option>
                </nz-select>
              </nz-form-control>

            </nz-form-item>
          </div>
          <div nz-col class="row-with-spacing-button">
            <button nz-button class="default-button" nzType="primary" (click)="onSearch()">
              <span nz-icon nzType="search"></span>
              {{ "Query" | translate}}</button>
          </div>

          <div nz-col class="row-with-spacing-button">
            <button nz-button class="default-button" nzType="primary" (click)="showModal()">
              <span nz-icon nzType="plus"></span>
              {{ "Add" |translate}}</button>
          </div>
        </div>
        <div nz-row>
          <div nz-col nzSpan="24">
            {{needAddSiteAdminGroupText}}
          </div>
        </div>

      </form>
    </nz-card>
    <nz-card>
      <div>
        <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
      </div>
      <div class="表格">
        <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger
          [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'
          [nzScroll]="{ y: '600px',x:'1500px' }">
          <thead>
            <tr>
              <th scope="col" nzWidth="65px" style="text-align:center;">{{ "SiteNo" | translate}}</th>
              <th scope="col" nzWidth="60px" style="text-align:center;">{{ "Site" | translate}}</th>
              <th scope="col" nzWidth="50px" style="text-align:center;">{{ "EmployeeID" | translate}}</th>
              <th scope="col" nzWidth="65px" style="text-align:center;">{{ "EmployeeName" | translate}}</th>
              <th scope="col" nzWidth="100px" style="text-align:center;">{{ "accendant" | translate}}</th>
              <th scope="col" nzWidth="50px" style="text-align:center;">{{ "maintenancetime" | translate}}</th>
              <th scope="col" nzWidth="50px" style="text-align:center;" [nzRight]="true">{{ "act" | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of colSpanTable.data;let i=index" style="text-align: center;">
              <td>{{data.siteNo}}</td>
              <td>{{data.siteName}}</td>
              <td>{{data.subjectId}}</td>
              <td>{{data.subjectName}}</td>
              <td>{{data.maintainer}}</td>
              <td>{{data.maintainerDate}}</td>
              <!-- <td>
                <button nz-button class="default-button" nzType="primary" (click)="Delete(data)">{{ "Delete" |
                  translate}}</button>
              </td> -->
              <td [nzRight]="true">
                <span nz-icon nzType="delete" nzTheme="twotone" (click)="Delete(data)"
                  style="font-size: 20px; cursor: pointer;"></span>
                <!-- <span nz-icon nzType="delete" nzTheme="outline" (click)="Delete(data)" style="font-size: 26px; cursor: pointer;"></span> -->
              </td>
            </tr>
          </tbody>
        </nz-table>
        <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
          nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]='pageSize'
          (nzPageSizeChange)="nzPageSizeChange($event)" (nzPageIndexChange)="nzPageIndexChange($event)">
        </nz-pagination>
        <ng-template #renderItemTemplate let-type let-page="page">

          <a *ngIf="type === 'page'">{{ page }}</a>
          <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
          <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
        </ng-template>
      </div>
    </nz-card>
  </div>
</nz-spin>

<nz-modal [(nzVisible)]="isVisible" nzTitle="{{'MaintainSiteadmin'|translate}}" (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()" nzOkText="{{'Submit'|translate}}" nzCancelText="{{'cancel'|translate}}">
  <ng-container *nzModalContent>

    <form nz-form [formGroup]="validateForm" style="margin-top: 20px;">
      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font">{{ "Site" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-select formControlName="Site">
                <nz-option *ngFor="let option of SiteList" [nzValue]="option.siteCode"
                  [nzLabel]="option.siteName"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font">{{ "Name/Id" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select [nzServerSearch]="true" formControlName="SubjectId" (nzOnSearch)="userSearch($event)"
                (ngModelChange)="onUserSelect($event)"
                style="border-radius:6px;" nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true"
                [nzShowSearch]="true">
                <nz-option *ngFor="let o of userOptionList" [nzValue]="o.userId"
                  nzLabel="{{o.userId}}/{{o.englishName}}" nzCustomContent>
                  <span>{{o.userId}}/{{o.englishName}}</span>
                </nz-option>
              </nz-select>
            </nz-form-control>

          </nz-form-item>
        </div>
      </div>

    </form>
  </ng-container>

</nz-modal>